import { render } from "./Placeholder.vue.js?vue&type=template&id=3bd1e6f4&scoped=true!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./Placeholder.vue?vue&type=template&id=3bd1e6f4&scoped=true"
const script = {}

import "./Placeholder.vue.scss?vue&type=style&index=0&id=3bd1e6f4&lang=scss&scoped=true!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./Placeholder.vue?vue&type=style&index=0&id=3bd1e6f4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd1e6f4"]])

export default __exports__